const updateFilters = (context, payload) => {
  context.commit('updateFilters', payload)
}

export default {
  updateFilters
}
